import React, { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import axios from "axios";

const Result = () => {
  return (
    // <p className="success-message">Your Message has been successfully sent. I will contact you soon.</p>
    <p className="success-message">
      정상적으로 메시지가 전송되었습니다. 곧 담당자가 연락드리겠습니다.
    </p>
  );
};
function ContactForm({ props }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    context: "",
    type: "1",
    phone: "",
    privacy: false,
  });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked,
      });
    } else if (type === "file") {
      setFormData({
        ...formData,
        [name]: e.target.files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const [result, showresult] = useState(false);
  // let data =FormData()
  // data.append("name")
  const sendEmail = (e) => {
    e.preventDefault();
    console.log(formData);
    const data = new FormData();
    console.log(formData);
    if (!formData.privacy) {
      return false;
    }
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    axios
      .post("https://ai.xrai-api.com/api/suggestion/create", data)
      .then((response) => {
        console.log(response.data);
        showresult(true);
        setFormData({
          name: "",
          email: "",
          context: "",
          type: "1",
          phone: "",
          privacy: false,
        });
      })
      .catch((error) => {
        console.error(error);
        if (error.response.status == 400) {
          alert("이미지 파일이 아니거나 잘못되었습니다. 다른파일을 올려주세요");
        }
      });
    e.target.reset();
    // showresult(true);
  };

  setTimeout(() => {
    showresult(false);
  }, 30000);

  return (
    <form action="" onSubmit={sendEmail}>
      <div className="rn-form-group">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Name"
          required
        />
      </div>

      <div className="rn-form-group">
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Your Email"
          required
        />
      </div>

      <div className="rn-form-group">
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Phone Number"
          required
        />
      </div>

      <div className="rn-form-group mb-3">
        <select name="type" value={formData.type} onChange={handleChange}>
          <option value={1}>일반 문의</option>
          <option value={2}>api 문의 </option>
          <option value={3}>api 체험문의</option>
          <option value={4}>AI 모델 개발문의</option>
          <option value={5}>기술문의</option>
          <option value={6}>제휴문의</option>
        </select>
      </div>

      <div className="rn-form-group mb-3">
        <textarea
          name="context"
          value={formData.context}
          onChange={handleChange}
          placeholder="Your Message"
          required
        ></textarea>
      </div>
      <div class="file-input-container mb-3">
        <label
          class="file-input-label"
          for="file-input"
          style={{ border: `1px solid #FFC20E` }}
        >
          파일 선택
        </label>

        <span class="file-input-text">
          {" "}
          {formData.file ? (
            <div style={{ width: `250px`, fontWeight: `bold` }}>
              {formData.file.name}
            </div>
          ) : (
            "선택된 파일 없음"
          )}
        </span>

        <input
          type="file"
          id="file-input"
          name="file"
          onChange={handleChange}
        />
      </div>
      {/* <div className='rn-form-group mb-3'>
                
                <input type='file' name='file' onChange={handleChange}></input>
            </div> */}
      <div className="mb-3 d-flex">
        <a
          className="description"
          href="/privacy"
          style={{ display: "flex", fontSize: "18px" }}
        >
          {" "}
          개인정보 수집에 동의합니다.
        </a>
        <input
          checked={formData.privacy}
          onChange={handleChange}
          type="checkbox"
          name="privacy"
          style={{ width: "4%", margin: "3px 1px 5px 11px", height: "auto" }}
        ></input>
      </div>
      <div className="rn-form-group">
        <button
          className="rn-button-style--2 btn-solid"
          type="submit"
          value="submit"
          name="submit"
          id="mc-embedded-subscribe"
        >
          Submit Now
        </button>
      </div>

      <div className="rn-form-group">{result ? <Result /> : null}</div>
    </form>
  );
}
export default ContactForm;
